
import React, { Component } from "react";
// reactstrap components
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  Media,
  UncontrolledTooltip,
  Row,
  Progress
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";

// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// connect
import connect from 'redux-connect-decorator';
import { getWords } from '../../../../actions/glossaryActions';
import { questionBank } from '../../../../actions/questionActions';
import { listExams } from '../../../../actions/examActions';
import { getUserInfo } from '../../../../actions/authActions';
import VoicePlayer from '../../components/VoicePlayer';
import { pagination } from '../../../../utils/ccl-utils';
import { withRouter, Link } from 'react-router-dom';

const { SearchBar } = Search;

const allItalic = (cell, row) => {
  return <i>{cell}</i>;
}

const formatTags = (cell, row) => {
  return <>
    <span className="badge badge-warning">HOT</span>
    <span className="badge badge-primary">TRENDING</span>
    <span className="badge badge-success">NEW</span>
  </>;
}

const formatNumberQuestion = (cell, row) => {
  return <Link to={ `#` }>
    <div style={{ textAlign: "center" }}><span className="badge badge-default text-sm">{ row.data.length } <span className="hidden-lg-down">questions</span></span></div>
  </Link>
}

const formatTopic = (cell, row) => {
  const progress = 100;
  return <div className="col">
      <small className="text-black">{ cell.toUpperCase() }</small>
      <Progress
        className="progress-xs my-2"
        max="100"
        value={ progress }
        color="success"
      />
    </div>;
}

const formatName = (cell, row) => {
  return <Media className="align-items-center">
      <a className="topic mr-3" onClick={e => e.preventDefault()}>
        <div className={`bg-topic bg-topic-default bg-topic-${cell.toUpperCase()}`}></div>
      </a>
      <Media>
        <span className="name mb-0 text-sm">
          { cell.toUpperCase() }
        </span>
      </Media>
    </Media>;
}

@connect(
  state => ({
    loading: state.exam.loading,
    exams: state.exam.exams
  }),
  {
    getUserInfo,
    listExams
  }
)
class MultipleChoiceHistory extends Component<any, any> {
  componentDidMount() {
    this.props.listExams();
    this.props.getUserInfo();
  }

  state = {
  };

  constructor(props) {
    super(props);
  }

  addActionButton = (cell, row) => {
    return (
        <div className="table-actions">
            <Link to={ `/user/multiple-choice/view?id=${row._id}` }>
              <Button className="btn-benit-sm btn-benit-white" type="button">
                <span className="btn-inner--icon">
                  <i className="fas fa-info" />
                </span>
                <span className="btn-inner--text hidden-lg-down ml-1">View</span>
              </Button>
            </Link>
        </div>
    )
  }

  render() {
    const { exams } = this.props;
    return (
      <>
        <SimpleHeader name="Multiple choice history" parentName="Home" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Multiple choice history</h3>
                  <p className="text-sm mb-0">All list multiple choice history</p>
                  <Link to={`/user/multiple-choice/list`}>
                    <Button
                        className="btn-benit-sm btn-benit-white benit-try-again"
                        type="button"
                    >
                      <span className="btn-inner--text hidden-lg-down">Back&nbsp;&nbsp;</span>
                      <span className="btn-inner--icon mr-1">
                        <i className="fas fa-ellipsis-v"></i>
                      </span>
                    </Button>
                  </Link>
                </CardHeader>
                <ToolkitProvider
                  data={ exams }
                  keyField="_id"
                  columns={[
                    {
                      dataField: "exam_title",
                      text: "Name",
                      sort: true,
                      formatter: formatName
                    },
                    {
                      dataField: "topic",
                      text: "Topic",
                      sort: true,
                      formatter: formatTopic
                    },
                    {
                      dataField: "score",
                      text: "Score"
                    },
                    {
                      dataField: "finished_date",
                      text: "Date"
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      searchable: false,
                      sort: false,
                      formatter: this.addActionButton
                    }
                  ]}
                  search
                >
                  {props => (
                    <div className="py-4 table-responsive align-items-center table-flush table">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter px-4 pb-1"
                      >
                        <label>
                          Search:
                          <SearchBar
                            className="form-control-sm"
                            placeholder=""
                            {...props.searchProps}
                          />
                        </label>
                      </div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={false}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default MultipleChoiceHistory;
